export const trainingsMixins = {
  methods: {
    changeMsToDays(durationInMs) {
      const millis = parseInt(durationInMs, 10);
      return this.$moment.duration(millis).asDays();
    },
    getCreatedAtDate(training) {
      let createdAtDate = '';
      if (training.states.date && training.states.state) {
        createdAtDate = training.states.date;
      }
      return createdAtDate;
    },
    getActiveToDate(training, durationInMs) {
      const createdAtDate = this.getCreatedAtDate(training);
      if (!createdAtDate) return '-';
      return this.$moment(createdAtDate).add(durationInMs).format('DD-MM-YYYY');
    },
    getStatus(training) {
      return training.states.state ? 'Active' : 'Inactive';
    },
    getStatusClass(training) {
      return `${training.states.state ? 'green--text' : 'custom-text-danger'} font-weight-bold`;
    },
    async fetchTrainingData(trainingId) {
      try {
        const response = await this.axios.get(`/users/me/trainings/${trainingId}`);
        return response.data;
      } catch {
        this.$notify({ type: 'error', title: 'Could not load training data' });
        return {};
      }
    },
  },
};
